/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentTemplate } from '../../models/content-template';

export interface GetContentTemplateByType$Params {

/**
 * typ šablóny
 */
  templateType: string;
}

export function getContentTemplateByType(http: HttpClient, rootUrl: string, params: GetContentTemplateByType$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentTemplate>> {
  const rb = new RequestBuilder(rootUrl, getContentTemplateByType.PATH, 'get');
  if (params) {
    rb.path('templateType', params.templateType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentTemplate>;
    })
  );
}

getContentTemplateByType.PATH = '/admin/contentTemplate/{templateType}';
